import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import RepoSelection from '../../components/modals/RepoSelection'
import {moveToRepo} from '../../utils/moveToRepo'
import {showNotification} from '../../actions/notifications'
import each from 'lodash/each'
import {fetchQuestionsNoMinTime} from '../../actions/library/questions'
import {fetchSetsNoMinTime} from '../../actions/library/sets'
import {fetchFolders} from '../../actions/library/folders'
import sortBy from 'lodash/sortBy'

class RepoSelectionContainer extends Component {

	constructor(){
		super()
		this.moveToRepo=this.moveToRepo.bind(this)

		this.state={
			submitLoading: false,
			selectedRepoId:null
		}

	}

	moveToRepo(repo){
		this.setState({submitLoading:true,selectedRepoId:repo.id})
		const {itemToMove,multiSelectItems}=this.props

		if(itemToMove){
			this.props.moveToRepo(itemToMove,repo.id,null).then(()=>{
				this.props.hideModal()
				const notificationMessage=`${itemToMove.name || itemToMove.body} to ${repo.name}`
				this.props.showNotification(notificationMessage,'Moved','default')
				this.props.fetchSetsNoMinTime()
				this.props.fetchQuestionsNoMinTime()
				this.props.fetchFolders()
				if(this.props.navigateToRepo){
					this.props.history.push(`/packs/${repo.id}`)
				}

			})
		}else if(multiSelectItems){
			let promises = []
			each(Object.keys(multiSelectItems), function(key) {
				const item=multiSelectItems[key]
				promises.push(this.props.moveToRepo(item,repo.id,null))			
		
			}.bind(this))

			Promise.all(promises).then(function () {
				this.props.hideModal()
				this.props.showNotification(`${Object.keys(multiSelectItems).length} items to ${repo.name}`,'Moved','default')		
				this.props.fetchQuestionsNoMinTime()
				this.props.fetchSetsNoMinTime()
				this.props.fetchFolders()
				if(this.props.navigateToRepo){
					this.props.history.push(`/packs/${repo.id}`)
				}
			}.bind(this))




		}

	} 

	render() {
		return (    
			<RepoSelection 
				submitLoading={this.state.submitLoading}
				selectedRepoId={this.state.selectedRepoId}
				repos={this.props.repos} 
				item={this.props.itemToMove} 
				multiSelectItems={this.props.multiSelectItems} 
				hideModal={this.props.hideModal} 
				moveToRepo={this.moveToRepo}/>
		)
	}
}


export default withRouter(connect(
	(state) => ({
		repos:sortBy(state.repos,[repo => repo.name.toLowerCase()]),
		itemToMove:state.modals.itemToMove,
		multiSelectItems:state.modals.multiSelectItemsToMove,
		navigateToRepo:state.modals.navigateToRepo
	}),
	{ moveToRepo,showNotification,fetchQuestionsNoMinTime,fetchSetsNoMinTime,fetchFolders}
)(RepoSelectionContainer))




// WEBPACK FOOTER //
// ./src/containers/modals/RepoSelectionContainer.js